var map = {
	"./accounts/accounts.module": [
		"./src/app/accounts/accounts.module.ts",
		"accounts-accounts-module"
	],
	"./clients/clients.module": [
		"./src/app/clients/clients.module.ts",
		"default~clients-clients-module~survey-survey-module",
		"clients-clients-module"
	],
	"./survey/survey.module": [
		"./src/app/survey/survey.module.ts",
		"default~clients-clients-module~survey-survey-module",
		"survey-survey-module"
	],
	"./users/users.module": [
		"./src/app/users/users.module.ts",
		"users-users-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;